import React from "react"
import { PackageUpsaleResAdmin } from "../../types/apiTypes"
import FieldMessage, { Field } from "../../components/Messages/FieldMessage"

export default function UpsaleListPurposeCell({
  isForWeb,
}: PackageUpsaleResAdmin) {
  return <FieldMessage id={isForWeb ? Field.IS_WEB : Field.IS_AGENCY} />
}
